import React from 'react';

export default {
  returnButtonLabel: 'Voltar',
  continueButtonLabel: 'Continuar',
  redemptDomain: 'Resgatar domínio',
  banner: {},
  inputDomainStep: {
    title: 'Qual será o endereço do seu site?',
    description: 'Digite o nome do domínio desejado e escolha entre as extensões disponíveis para resgatar seu domínio gratuito.',
    tooltipLabel: 'Após um ano, a renovação do domínio terá um custo.',
    searchTld: 'Buscar extensão',
    freeTag: 'Grátis',
    otherOptionsLabel: 'Veja algumas alternativas para você:',
    myDataButtonLabel: 'Meus dados',
    radixUnavailable: (domain, radixDomain) => (
      <>
        {'O domínio '}
        <strong>{`"${radixDomain}"`}</strong>
        {' já tem dono. Ao clicar em "Continuar", você irá registrar apenas o '}
        <strong>{`"${domain}"`}</strong>
      </>
    ),
    invalidDocumentDescription: (
      <>
        <strong>
          {'Para continuar, acesse a página Meus Dados e atualize suas informações. '}
        </strong>
        Depois, retorne para este fluxo para concluir sua compra.
      </>
    ),
    inputErrors: {
      invalidDomain: 'Domínio inválido',
      startOrEndWithHyphen: 'O domínio não pode começar ou terminar com hífen',
      twoHyphensInARow: 'O domínio não pode ter dois hífens seguidos',
      lessThanThreeCharacters: 'Use 3 caracteres ou mais para seu domínio',
      hasSpecialChars: 'O domínio não pode ter caracteres especiais, com exceção do hífen',
      domainIsUnavailable: 'Parece que esse domínio já tem dono. Experimente outro nome ou escolha uma das opções disponíveis!',
      unavailableWithoutChoose: 'Domínio indisponível. Experimente outro nome ou escolha uma das opções disponíveis!',
      documentIsInvalid: 'Seu documento não atende aos requisitos para a compra ou indica que você é menor de 18 anos.',
    },
  },
  planTurboFreeDomainStep: {
    title: 'Deseja ativar mais um domínio gratuito?',
    description: 'Com o Plano Turbo, você tem direito a um segundo domínio gratuito por um ano.',
    activeRadix: {
      title: 'Ativar domínio gratuito',
      about: 'Seu domínio será registrado sem custo. Após um ano, será necessário renová-lo mediante pagamento.',
    },
    refuseRadix: {
      title: 'Não ativar o domínio gratuito',
      about: 'Caso opte por não ativar, você perderá o direito a esse domínio gratuito.',
    },
  },
  successStep: {
    content: ({ domains }) => {
      const singleDomain = {
        description: `Seu domínio "${domains[0]}" foi registrado com sucesso!`,
        infoList: ['Agora ele está disponível para uso na sua conta'],
        renewalNotice: 'Após um ano, a renovação do domínio terá um custo.',
      };

      const multipleDomains = {
        description: `Os domínios "${domains[0]}" e "${domains[1]}" foram registrados com sucesso!`,
        infoList: ['Agora eles estão disponíveis para uso na sua conta'],
        renewalNotice: 'Após um ano, a renovação dos domínios terá um custo.',
      };

      return ({
        title: 'Ótima escolha!',
        ...domains.length === 1 ? singleDomain : multipleDomains,
      });
    },
  },
};
